import { IContact } from "./contact.types";

export class Contact implements IContact {
  serviceUid: string;
  name: string;
  officeNumber: string;
  contactBeginHour: number;
  contactBeginMin: number;
  contactEndHour: number;
  contactEndMin: number;
  campusCode: string;
  campusName: string;

  constructor(data: IContact) {
    this.serviceUid = data.serviceUid;
    this.name = data.name;
    this.officeNumber = data.officeNumber;
    this.contactBeginHour = data.contactBeginHour;
    this.contactBeginMin = data.contactBeginMin;
    this.contactEndHour = data.contactEndHour;
    this.contactEndMin = data.contactEndMin;
    this.campusCode = data.campusCode;
    this.campusName = data.campusName;
  }
}
